import React from "react";

const TimesIcon = () => (
  <svg className="times-icon" x="0px" y="0px" viewBox="0 0 24 29">
    <g id="timer" transform="translate(-22.122 1)">
      <path
        id="Path_155"
        d="M35.967,4.233V2.2h.926a1.1,1.1,0,0,0,0-2.2H31.646a1.1,1.1,0,0,0,0,2.2h.926V4.233a11.01,11.01,0,1,0,3.395,0Zm-1.7,19.684a8.805,8.805,0,1,1,8.805-8.805A8.815,8.815,0,0,1,34.27,23.917Z"
        stroke="#656588"
        strokeWidth="0.4"
      />
      <path
        id="Path_156"
        d="M137.818,101.086V95.893a1.1,1.1,0,1,0-2.2,0v5.829a.674.674,0,0,0,.2.478l3.084,3.071a1.1,1.1,0,0,0,1.556-1.562Z"
        transform="translate(-102.447 -86.432)"
        stroke="#656588"
        strokeWidth="0.4"
      />
      <rect
        id="Rectangle_68"
        width="24"
        height="29"
        transform="translate(22.122 -1)"
        fill="none"
        stroke="none"
        strokeWidth="0"
      />
    </g>
  </svg>
);

export default TimesIcon;
